import { ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import appIcon from "../assets/app-icon.png";

const BG_IMAGE = "https://images.pexels.com/photos/29590119/pexels-photo-29590119.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600";

export default function Login() {
  const { login } = useAuth();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-white relative overflow-hidden bg-slate-950" data-testid="login-page">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${BG_IMAGE})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/85 via-slate-950/80 to-slate-950/95" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,rgba(16,185,129,0.25),transparent_45%),radial-gradient(circle_at_85%_90%,rgba(2,132,199,0.22),transparent_45%)]" />
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "42px 42px",
        }}
      />
      <div className="absolute top-0 left-0 right-0 h-1.5 bg-[repeating-linear-gradient(45deg,#f59e0b_0,#f59e0b_14px,#0f172a_14px,#0f172a_28px)]" />

      <div className="relative z-10 max-w-md w-full text-center space-y-8">
        <div className="flex flex-col items-center gap-3">
          <div className="p-2 rounded-2xl bg-emerald-600/20 border border-emerald-500/40 shadow-[0_0_40px_rgba(16,185,129,0.35)]">
            <img src={appIcon} alt="World Class Energy Isolation" className="h-20 w-20 rounded-xl" data-testid="login-app-icon" />
          </div>
          <h1 className="font-heading font-black uppercase text-3xl sm:text-4xl tracking-tight drop-shadow-lg" data-testid="login-title">
            World Class Energy Isolation
          </h1>
          <p className="text-slate-300 text-sm">Lafarge Ciments France — Direction Santé &amp; Sécurité</p>
        </div>

        <div className="bg-slate-900/70 backdrop-blur-md border border-slate-700/80 rounded-xl p-6 space-y-4 shadow-2xl">
          <div className="flex items-center justify-center gap-2 text-sm text-slate-300">
            <ShieldCheck className="h-4 w-4 text-emerald-400" /> Accès sécurisé réservé aux équipes HSE
          </div>
          <button
            data-testid="google-login-button"
            onClick={login}
            className="w-full bg-white text-slate-900 font-semibold rounded-lg py-3 flex items-center justify-center gap-2 hover:bg-slate-100 transition-colors"
          >
            <svg width="18" height="18" viewBox="0 0 48 48">
              <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.6 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.7-.4-3.5z" />
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.9 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.5 6.1 29.5 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
              <path fill="#4CAF50" d="M24 44c5.3 0 10.1-1.8 13.9-4.9l-6.4-5.4C29.6 35.6 26.9 36 24 36c-5.3 0-9.8-3.4-11.4-8.1l-6.6 5.1C9.5 39.6 16.2 44 24 44z" />
              <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.7 2-2 3.7-3.7 5l6.4 5.4C41.8 35.6 44 30.2 44 24c0-1.3-.1-2.7-.4-3.5z" />
            </svg>
            Se connecter avec Google
          </button>
        </div>
        <p className="text-xs text-slate-400">Référentiel Holcim — 43 Minimum Requirements · 19 World Class Requirements</p>
        <Link to="/confidentialite" data-testid="login-privacy-link" className="text-xs text-slate-500 hover:text-slate-300 underline underline-offset-2 block">
          Politique de confidentialité &amp; RGPD
        </Link>
      </div>
    </div>
  );
}
